import { ControlType, FetchStatus, IEntity, Property, PropertyType } from "../../../base/types"
import { DataContextProvider, useDataContext } from "../../page/context"
import { IControlAttributes, IControlBaseAttributes } from "../../../base/models"
import React, { FC, useEffect } from "react"

import { AlertMessage } from "../../../widgets"
import { DesignerMode } from "../../types"
import { Registry } from "../../../base/register"
import { RepeaterColumnHeader } from "./RepeaterColumnHeader"
import { useDesignContext } from "../../../providers"
import { useGetProperties } from "../../../base/hooks"

export const RepeaterComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, onDesignChange, ...rest
}) => {
    const { properties } = useGetProperties({ bindings: control.bindings });
    const tooltip: string | undefined = properties[Property.Tooltip];

    if (designerMode === DesignerMode.Draft) {
        return (
            <div style={{ display: 'table' }} className={className} title={tooltip}>
                <div style={{ display: 'table-header-group' }}>
                    <Headers
                        control={control}
                        children={children}
                        orientation="Auto"
                        onDesignChange={onDesignChange} />
                </div>
            </div>
        )
    }


    return (
        <table className={className} title={tooltip}>
            <thead>
                <Headers
                    control={control}
                    orientation="Auto"
                    onDesignChange={onDesignChange} />
            </thead>
            <tbody>
                <RepeaterRows control={control} children={children} orientation="Auto" onDesignChange={onDesignChange} />
            </tbody>
        </table>
    )
}

const RepeaterRows = ({ children }: IControlBaseAttributes) => {
    const { type, result: data, status } = useDataContext()

    if (status !== FetchStatus.Success)
        return <></>

    if (type !== "List")
        return <AlertMessage message="Not a list" />

    return <>
        {data.records.map((row, index) =>
            <React.Fragment key={index}>
                <DataContextProvider>
                    <RowProducer data={row} />
                    <tr>
                        {!children && <>No children</>}
                        {children}
                    </tr>
                </DataContextProvider>
            </React.Fragment>
        )}
    </>
}

const RowProducer = ({ data }: { data: IEntity }) => {
    const { setData } = useDataContext()

    useEffect(() => {
        setData({ type: "Card", result: data, status: FetchStatus.Success })
        // eslint-disable-next-line
    }, [])

    return <></>
}

const Headers = ({ control, className, children }: IControlBaseAttributes) => {
    const { control: { designerMode } } = useDesignContext()

    if (designerMode === DesignerMode.Draft) {
        return <>
            <div style={{ display: "table-row" }} className={className}>
                <div style={{ display: "table-cell" }} className={className}>
                </div>

                {control.controls?.map((column) => <React.Fragment key={column.controlId}>
                    <RepeaterColumnHeader control={column} orientation="Horizontal" onDesignChange={() => { }} />
                </React.Fragment>)}
            </div>
            <div style={{ display: "table-row" }} className={className}>
                {children}
            </div>
        </>
    }

    return <>
        <tr className={className}>
            {control.controls?.map((column) => <React.Fragment key={column.controlId}>
                <RepeaterColumnHeader control={column} orientation="Horizontal" onDesignChange={() => { }} />
            </React.Fragment>)}
        </tr>
        <tr className={className}>
            {children}
        </tr>
    </>
}

Registry.addControl({
    id: "24068773-b1be-4da3-91f8-8b2647c6003e",
    name: "Repeater",
    type: ControlType.Repeater,
    properties: [
        { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String }
    ],
    component: RepeaterComponent
})
